import React from 'react';
import { useAppDispatch } from '@wfp-root-app/store/store';
import { useLocation, useNavigate, useParams, useOutletContext } from 'react-router-dom';

import { ActionCreators } from './partnersActions';
import { defaultPartnerSortOptions, PartnerGeneralInfo } from './partners';
import PermissionsFiles from '../permissions-files/PermissionsFiles';
import { ManagerPermission } from '../permission-profiles/permission';

interface Props {
    partner: PartnerGeneralInfo;
}

const PartnerPermissionsFiles: React.FC<Props> = ({ partner }) => {
    const dispatch = useAppDispatch();

    const uploadPermissionsFile = (userId: string, file: File) => {
        return dispatch(ActionCreators.uploadPermissionsFile(userId, file));
    };

    const loadPartners = () => {
        dispatch(ActionCreators.loadPartners(defaultPartnerSortOptions));
    };

    return (
        <PermissionsFiles
            loadUsers={loadPartners}
            permissionsFiles={partner.permissionFiles}
            requiredPermission={[ManagerPermission.partnerPost, ManagerPermission.partnerPark]}
            uploadPermissionsFile={uploadPermissionsFile}
            userId={partner.id}
        />
    );
};

PartnerPermissionsFiles.displayName = 'PartnerPermissionsFiles';

const withHooks = (Component: any) => {
    // eslint-disable-next-line react/display-name
    return (props: any) => {
        const location = useLocation();
        const params = useParams();
        const navigate = useNavigate();
        const dispatch = useAppDispatch();
        const outletContext = useOutletContext<{
            generalInfoProps?: any;
            activityLogsProps?: any;
            partnerGeneralInfo?: PartnerGeneralInfo;
        }>();

        // Use props from outlet context if available (for nested routes), otherwise use passed props
        const finalProps = outletContext?.partnerGeneralInfo ? { partner: outletContext.partnerGeneralInfo } : props;

        return (
            <Component {...finalProps} dispatch={dispatch} location={location} navigate={navigate} params={params} />
        );
    };
};

export default withHooks(PartnerPermissionsFiles);
